export default __webpack_public_path__ + "static/media/Ornela Vorspi premiata.3b8865f1.jpg";